import React, { useContext } from "react";
import { createPortal } from "react-dom";
import { useTheme } from "@material-ui/styles";
import {
  Theme,
  Select,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { useTranslate, Identifier } from "react-admin";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import { useAppData } from "../../../common/hooks/useAppData";
import { AppBarFiltersContainerContext } from "../app-bar-filters/AppBarFiltersContainerContext";

interface AppbarGroupFilterProps {
  selectedGroup?: Identifier;
  onSelectedGroupChange?: (id: Identifier) => void;
}

export const AppbarGroupsFilter = ({
  selectedGroup,
  onSelectedGroupChange,
}: AppbarGroupFilterProps) => {
  const theme: Theme = useTheme();
  const translate = useTranslate();
  const groups = useAppData((x) => x.groups) ?? [];
  const { container: appbarFiltersContainer } = useContext(
    AppBarFiltersContainerContext
  );

  const renderEmptyGroupAppbarFilter = (header: boolean) => (
    <MenuItem className="appbar-filter-list-item" value="">
      <ListItemIcon
        style={{ color: header ? theme.palette.common.white : "auto" }}>
        <LocalShippingIcon />
      </ListItemIcon>
      <ListItemText>
        <Typography variant="body2">
          {translate("resources.common.labels.allAssets")}
        </Typography>
      </ListItemText>
    </MenuItem>
  );

  const renderGroupAppbarFilterValue = (id: Identifier, header: boolean) => (
    <MenuItem key={id} className="appbar-filter-list-item" value={id}>
      <ListItemIcon
        style={{ color: header ? theme.palette.common.white : "auto" }}>
        <LocalShippingIcon />
      </ListItemIcon>
      <ListItemText>
        <Typography variant="body2">
          {groups.find((x) => x.id === id)?.name}
        </Typography>
      </ListItemText>
    </MenuItem>
  );

  if (!groups.length) {
    return null;
  }

  return appbarFiltersContainer
    ? createPortal(
        <>
          <Select
            autoFocus={false}
            className="appbar-filter"
            disableUnderline
            label=""
            value={selectedGroup}
            displayEmpty
            renderValue={(value) => {
              if (!value || value === "") {
                return renderEmptyGroupAppbarFilter(true);
              }

              return renderGroupAppbarFilterValue(value as Identifier, true);
            }}
            onChange={(e) =>
              onSelectedGroupChange &&
              onSelectedGroupChange(e.target.value as Identifier)
            }>
            {renderEmptyGroupAppbarFilter(false)}
            {groups.map((group) =>
              renderGroupAppbarFilterValue(group.id ?? "", false)
            )}
          </Select>
        </>,
        appbarFiltersContainer
      )
    : null;
};
